import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedMainService {
  public subjectName = new Subject<any>()

  sendUpdate() {
    this.subjectName.next(0)
  }

  getUpdate(): Observable<any> {
    return this.subjectName.asObservable()
  }
}
